<script setup lang="ts">
  import { IElement, PageElementOptions } from '@gohighlevel/ghl-proposals-common'
  import BlocksRenderer from '../common/BlocksRenderer.vue'
  import FloatingElementRenderer from '../common/FloatingElementRenderer.vue'
  import { ref } from 'vue'

  const props = defineProps<{
    page: IElement<PageElementOptions>
    sectionType: string
  }>()

  const pageParentRef = ref<HTMLElement>()

  // Header/footer sections: fillables are positioned relative to this section (same as builder)
  const isInHeaderOrFooter = true

  const getDraggableElement = (children: IElement[]) => {
    if (!children) return []
    return children.filter(element => element && element?.component?.isDraggable)
  }

  const getBlockElements = (children: IElement[]) => {
    if (!children) return []
    return children.filter(element => element && !element?.component?.isDraggable)
  }
</script>

<template>
  <div class="document-block page-section-positioned" style="flex: 1 1 0%; width: 100%; display: flex; flex-direction: column">
    <FloatingElementRenderer
      :elements="getDraggableElement(props.page.component.options[props.sectionType]?.children)"
      :page-id="props.page.id"
      :page="props.page"
      :page-ref="pageParentRef"
      :parent-ref="pageParentRef"
      :crossings="[]"
      :type="'signature'"
      :is-parent-page="true"
      :is-in-header-or-footer="isInHeaderOrFooter"
      :apply-print-adjustment="true"
    />
    <template v-for="(element, index) in getBlockElements(props.page.component.options[props.sectionType]?.children)" :key="index">
      <BlocksRenderer
        :page="props.page"
        :page-ref="pageParentRef"
        :parent-ref="pageParentRef"
        :element="element as IElement<any>"
        :page-id="props.page.id as string"
        v-if="!element.component.isDraggable"
      />
    </template>
  </div>
</template>

<style scoped>
  /* Positioning context for header/footer fillables (matches builder section) */
  .document-block.page-section-positioned {
    position: relative;
  }
</style>
